import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function WmsPhysicalStockCount_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/WmsPhysicalStock" ? (
        <div>
          <span className="breadcrumb-not-active ">PhysicalStock </span>
        </div>
      ): vPathName === "/WmsPhysicalStockCount" ? (
        <div className={"d-flex align-items-center"}>
          <div>
            <span className="breadcrumb-not-active">Counting </span>
          </div>
        </div>
      )  : vPathName === "/WmsPhysicalStockDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/WmsPhysicalStockCount"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            Counting
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">PhysicalStockDetail </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default WmsPhysicalStockCount_BreadCrumbs;
